import NetworkManager from "../../../network/network-manager";
import Parser from "../network/parser.js";
export default {
  async loadCareersPaginated(context, payload) {
    await NetworkManager.post(
      context,
      `career/find-all-paginated`,
      payload,
      "PaginationResponse",
      "setPaginatedCareers",
      Parser
    );
  },
   async careerColumnsChangeStatus(context, payload) {
      await NetworkManager.put(
        context,
        `/career-column-name/active-status`,
        payload,
        null,
        null,
        Parser
      );
    },
  async downloadCareersExcel() {
    return await NetworkManager.download(`/career/export`);
  },
  async deleteCareers(context, payload) {
    await NetworkManager.put(
      context,
      `career/marked-as-deleted/${payload.id}`,
      payload,
      null,
      "deleteCareers",
      Parser
    );
  },
  async getCareerById(context, payload) {
    await NetworkManager.get(
      context,
      `career/${payload}`,
      null,
      "setCareerItem",
      Parser
    );
  },
  async loadCareerColumnsNames(context) {
    await NetworkManager.get(
      context,
      `career-column-name`,
      "CareerColumnsNames",
      "setCareerColumnsNames",
      Parser
    );
  },
    async editCareerColumnName(context, payload) {
      await NetworkManager.put(
        context,
        `career-column-name/${payload.id}`,
        payload,
        "CareerColumnsNames",
        null,
        Parser
      );
    }
};
